import '../lib/leaflet-icons.js'
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'

import { TILE_URL, TILE_ATTRIBUTION } from '../lib/basemap.js'

// Single-marker venue map for the event detail page (#39). Same tiles as
// EventMap, but no clustering and a tight default zoom. Caller is expected
// to check lat/lng before mounting — we don't render a fallback here.

export default function EventVenueMap({ event }) {
  const center = [event.lat, event.lng]
  const popupTitle = event.venue || event.address || event.title

  return (
    <div className="overflow-hidden rounded-2xl ring-1 ring-slate-200/60 shadow-sm">
      <MapContainer
        center={center}
        zoom={14}
        scrollWheelZoom={false}
        className="h-[40vh] min-h-[280px] w-full sm:h-[50vh]"
      >
        <TileLayer url={TILE_URL} attribution={TILE_ATTRIBUTION} />
        <Marker position={center}>
          <Popup>
            <div className="text-sm font-medium text-slate-900">{popupTitle}</div>
          </Popup>
        </Marker>
      </MapContainer>
    </div>
  )
}
